import { useEffect } from 'react'
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'

function HtmlAnchor() {
    useEffect(() => {
        setTimeout(() => {
            if (window.location.hash) {
                const id = window.location.hash.slice(1)
                const element = document.getElementById(id)
                if (element) {
                    element.scrollIntoView()
                }
            }
        }, 0)
    }, [])

    return <BlockWrapper.Without />
}

export default defineBlock({
    Block: HtmlAnchor,
    smartProps: {},
    setup: {
        title: 'html-anchor',
        parent: [],
    },
})
